import IntlProvider from '@amzn/bui-intl/lib/components/intl-provider';
import { ThemeProvider, FeatureFlagsProvider, Flags, Variants } from '@amzn/ink-react';
import { I18nProvider } from 'react-aria';

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

function AppRoot() {
    const appLocale = "en-US"
    return (
        <React.StrictMode>
			<FeatureFlagsProvider featureFlags={{
				[Flags.COLLECTION_SELECT_ALL_BEHAVIOR]: Variants.Variant1
			}}>
				<IntlProvider
					locale={appLocale}
					messageLoader={async (locale: string) =>
						(await import(`@translations/strings-${locale}.puff.json`)).default
					}
				>
					<I18nProvider locale={appLocale}>
						<ThemeProvider>
							<App />
						</ThemeProvider>
					</I18nProvider>
				</IntlProvider>
			</FeatureFlagsProvider>
        </React.StrictMode>
    );
}

const el = document.getElementById('root');

if (el) {
    const root = createRoot(el);
    root.render(<AppRoot />);
}
